import { isLocalhost } from '../modules/utilities';

const GET_COMPARE_URL = '/maa-api/compare/v1/list';
const COMPARE_URL = '/maa-api/compare/v1/';
const maxCompare = 5;

export const getComparedItems = async () => {
  if(!isLocalhost()){
    return fetch(GET_COMPARE_URL)
      .then(response => response.json())
      .then(response => {
        console.log(response);
        if (response.success != true) {
          return console.error('API error occurred');
        }
        return response.properties;
      })
      .catch(console.error);
  }
}

export const toggleCompare = (id) => {
  document.querySelectorAll(`[data-id="${id}"][href="#compare"]`).forEach((item) => {
    item.classList.toggle('compared');
  });
}

const removeFromCompareEvent = (id) => {
  document.dispatchEvent(new CustomEvent('removeFromCompare', {
    bubbles: true,
    detail: {
      Id: id,
    }
  }));
}

const addToCompareEvent = (propertyDetails) => {
  document.dispatchEvent(new CustomEvent('addedToCompare', {
    bubbles: true,
    detail: propertyDetails,
  }));
}

export const removeFromCompare = (id) => {
  if (isLocalhost()) {
    toggleCompare(id);
    removeFromCompareEvent(id);
    return Promise.resolve();
  }
  return fetch(COMPARE_URL + id, {
    method: 'DELETE',
  })
    .then(res => {
      if (res.status !== 200) {
        throw new Error(res.statusText);
      }
      toggleCompare(id);
      removeFromCompareEvent(id);
    });
}

export const addToCompare = (id) => {
  const compareCount = document.querySelector('.compare-communities__list .community-list').getAttribute('data-count');
  if(compareCount < maxCompare){
    return fetch(COMPARE_URL + id, {
      method: 'POST',
    })
      .then(response => response.json())
      .then(response => {
        toggleCompare(id);
        addToCompareEvent(response);
      });
  } else {
    return false;
  }
}

export const handleAddToCompare = async (e) => {
  const target = e.currentTarget;
  const isCompared = target.classList.contains('compared')
  const id = target.getAttribute('data-id');
  const compareCount = document.querySelector('.compare-communities__list .community-list').getAttribute('data-count');

  if (isLocalhost()) {
    return Promise
      .resolve()
      .then(() => {
        const response = {
          "Id": id,
          "Image": "-/media/images/properties/georgia/atlanta/maa-dunwoody/slides/2022/3-pool-3.jpg?w=84&h=56",
          "Neighborhood": "Dunwoody|Perimeter Center",
          "PropertyName": "MAA Dunwoody",
          "FloorplanName": null,
          "Url": "/georgia/atlanta/maa-dunwoody/",
          "UnitType": null,
          "Price": 0.0,
          "MoveInDate": null,
          "IsSaved": true,
        };

        if (isCompared) {
          removeFromCompareEvent(id);
          toggleCompare(id);
        } else if(compareCount < maxCompare) {
          addToCompareEvent(response);
          toggleCompare(id);
        } else {
          return false;
        }
      })
  }
  return isCompared ? removeFromCompare(id) : addToCompare(id);
}




// WEBPACK FOOTER //
// ./src/js/api/compare.js